import React from "react";
import { Link } from "react-router-dom";

import { MdOutlineAdminPanelSettings, MdPhoneInTalk } from "react-icons/md";
import { HiOutlineArrowNarrowRight } from "react-icons/hi";
import { useGetBlogsQuery } from "../../products/productSlice";

import footer from "../../../assets/img/footer-bg.png";

import blog1 from "../../../assets/img/broucher1.avif";
import blog2 from "../../../assets/img/broucher2.avif";
import blog3 from "../../../assets/img/broucher3.avif";
import blog4 from "../../../assets/img/broucher4.avif";

const newsArray = [
  {
    id: 1,
    date: "02 Apr",
    url: blog1,
    shortInfo:
      "Cagliata is a soft, semi-finished cheese made from pasteurized cow's milk and rennet..",
    title: "Technical Articles",
    desc: "GGAS a part of the illustrious GGAS, is one of India’s largest listed, diversified engineering and construction company",
    link: "Read more",
  },
  {
    id: 2,
    date: "02 Apr",
    url: blog2,
    category: "Blog",
    shortInfo:
      "Incorporating whole grains into your diet can have a profound impact on your health.",
    title: "Industry News",
    desc: "GGAS a part of the illustrious GGAS, is one of India’s largest listed, diversified engineering and construction company",
    link: "Read more",
  },
  {
    id: 3,
    date: "02 Apr",
    url: blog3,
    category: "Blog",
    shortInfo: "I got my first premium designer bag when I was...",
    title: "Case Studies?",
    desc: "GGAS a part of the illustrious GGAS, is one of India’s largest listed, diversified engineering and construction company",
    link: "Read more",
  },
  {
    id: 4,
    date: "02 Apr",
    url: blog4,
    shortInfo:
      "The Amazing Health Benefits of Broccoli: Why You Should Add It to Your Plate",
    title: "Safety and Compliance",
    desc: "GGAS a part of the illustrious GGAS, is one of India’s largest listed, diversified engineering and construction company",
    link: "Read more",
  },
  {
    id: 5,
    date: "02 Apr",
    url: blog1,
    category: "Blog",
    shortInfo:
      "Celery is a low-calorie vegetable with a crisp texture and a wide range of health benefits",
    title: "New Technologies",
    desc: "GGAS a part of the illustrious GGAS, is one of India’s largest listed, diversified engineering and construction company",
    link: "Read more",
  },
  {
    id: 6,
    date: "02 Apr",
    url: blog2,
    category: "Blog",
    shortInfo:
      "Parsley is often used as a decorative garnish, but this vibrant herb has much more to offer than...",
    title: "Maintenance and Overhaul",
    desc: "GGAS a part of the illustrious GGAS, is one of India’s largest listed, diversified engineering and construction company",
    link: "Read more",
  },
  {
    id: 7,
    date: "02 Apr",
    url: blog3,
    category: "Blog",
    shortInfo:
      "Parsley is often used as a decorative garnish, but this vibrant herb has much more to offer than...",
    title: "The Importance of Maintenance",
    desc: "GGAS a part of the illustrious GGAS, is one of India’s largest listed, diversified engineering and construction company",
    link: "Read more",
  },
  {
    id: 8,
    date: "02 Apr",
    url: blog4,
    category: "Blog",
    shortInfo:
      "Parsley is often used as a decorative garnish, but this vibrant herb has much more to offer than...",
    title: "Blog",
    desc: "GGAS a part of the illustrious GGAS, is one of India’s largest listed, diversified engineering and construction company",
    link: "Read more",
  },
];
function BlogItem() {
  const { data, isLoading } = useGetBlogsQuery();
  return (
    <>
      <section className="blogItemSec">
        <div className="row">
          {isLoading && (
            <div className="preloaderCount">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}
          {newsArray.map((item) => {
            return (
              <div key={item.id} className="col-lg-6">
                <div
                  className="blogItemInfo bgGray  brochuresItems"
                  style={{
                    backgroundImage: `url(${footer})`,
                    backgroundSize: "cover",
                  }}
                >
                  <div className="eventFigure">
                    <img src={item.url} className="img-fluid" alt="Blog" />
                    <div className="postDate">
                      <span className="date">25</span>
                      <span className="month">feb</span>
                    </div>
                  </div>
                  <div className="eventContent">
                    <div className="blogItemContent">
                      <div className="author">
                        <ul>
                          <li>
                            {/* <Link to={`/blog-detail/${item.uid}/${item.slug}`}> */}
                            <Link to={`/blog-detail/${item.id}`}>
                              <MdOutlineAdminPanelSettings />
                              By Ismail
                            </Link>
                          </li>
                          <li>
                            {/* <Link to={`/blog-detail/${item.uid}/${item.slug}}`}> */}
                            <Link to={`/blog-detail/${item.id}`}>
                              {" "}
                              <MdPhoneInTalk /> Consulting
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <h4>
                      {/* <Link to={`/blog-detail/${item.uid}/${item.slug}`}> */}
                      <Link to={`/blog-detail/${item.id}`}>{item.title}</Link>
                    </h4>
                  </div>
                </div>
              </div>
            );
          })}
          {/* {data &&
            data.map((item) => {
              return (
                <div key={item._id} className="col-lg-6">
                  <div className="blogItemInfo">
                    <div className="blogItemFigure">
                      <img
                        src={item.banner.url}
                        style={{ height: "400px" }}
                        alt="Blog"
                      />
                      <div className="postDate">
                        <span className="date">25</span>
                        <span className="month">feb</span>
                      </div>
                    </div>
                    <div className="blogItemContent">
                      <div className="author">
                        <ul>
                          <li>
                            <Link to={`/blog-detail/${item.uid}/${item.slug}`}>
                              <MdOutlineAdminPanelSettings />
                              By Ismail
                            </Link>
                          </li>
                          <li>
                            <Link to={`/blog-detail/${item.uid}/${item.slug}}`}>
                              {" "}
                              <MdPhoneInTalk /> Consulting
                            </Link>
                          </li>
                        </ul>
                      </div>
                      <div className="title">
                        <h4>
                          <Link to={`/blog-detail/${item.uid}/${item.slug}`}>
                            {item.title}
                          </Link>
                        </h4>
                        <p>{item.short_description}</p>
                      </div>
                      <div className="readMore">
                        <Link to={`/blog-detail/${item.uid}/${item.slug}`}>
                          Read More <HiOutlineArrowNarrowRight />{" "}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })} */}
        </div>
      </section>
    </>
  );
}

export default BlogItem;
